/* Site chrome behaviour — header (2026-09 redesign). Plain JS, no jQuery.
   Markup: sections/header.liquid. Everything here degrades to a working page without it:
   the badge reads "Carmel, IN", the nav is plain links, search submits to /search. */
(function () {
  'use strict';

  var header = document.querySelector('[data-sc-header]');
  if (!header) return;

  /* ---- Open / closed badge ------------------------------------------------
     data-hours is {"tz": "...", "days": [[open, close] | null ×7, Monday first]}
     from snippets/shop-hours (format: 'json'), i.e. Theme settings → Shop hours. */
  var DAY_ABBR = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  function toMinutes(hhmm) {
    var p = String(hhmm).split(':');
    return parseInt(p[0], 10) * 60 + parseInt(p[1] || '0', 10);
  }

  /* The wording comes from the theme locale files (general.header.hours) via the
     badge's data-labels, so the Spanish site reads Spanish. English is the fallback. */
  var EN = {
    open_until: 'Open until %TIME%', opens_today: 'Closed · opens %TIME%',
    opens_tomorrow: 'Closed · opens tomorrow %TIME%', opens_day: 'Closed · opens %DAY% %TIME%',
    am: '%TIME%a', pm: '%TIME%p', days: 'Mon,Tue,Wed,Thu,Fri,Sat,Sun'
  };

  function fill(tpl, time, day) {
    return tpl.replace('%TIME%', time).replace('%DAY%', day || '');
  }

  function clock(mins, L) {         // 1020 -> "5p", 600 -> "10a", 870 -> "2:30p" (English)
    var h = Math.floor(mins / 60), m = mins % 60;
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return fill(h < 12 ? L.am : L.pm, m ? h12 + ':' + (m < 10 ? '0' : '') + m : String(h12));
  }

  function shopNow(tz) {            // day index (Mon = 0) and minutes past midnight, in the shop's zone
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz, weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
    }).formatToParts(new Date());
    var get = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; };
    return { day: DAY_ABBR.indexOf(get('weekday')), mins: parseInt(get('hour'), 10) * 60 + parseInt(get('minute'), 10) };
  }

  function statusFor(data, L) {
    var now = shopNow(data.tz);
    if (now.day < 0) return null;
    var today = data.days[now.day];
    if (today && now.mins >= toMinutes(today[0]) && now.mins < toMinutes(today[1])) {
      return { open: true, text: fill(L.open_until, clock(toMinutes(today[1]), L)) };
    }
    if (today && now.mins < toMinutes(today[0])) {
      return { open: false, text: fill(L.opens_today, clock(toMinutes(today[0]), L)) };
    }
    for (var i = 1; i <= 7; i++) {
      var d = (now.day + i) % 7;
      if (data.days[d]) {
        var t = clock(toMinutes(data.days[d][0]), L);
        if (i === 1) return { open: false, text: fill(L.opens_tomorrow, t) };
        return { open: false, text: fill(L.opens_day, t, L.days.split(',')[d] || DAY_ABBR[d]) };
      }
    }
    return null;                     // no hours set at all: keep the "Carmel, IN" fallback
  }

  function renderStatus() {
    var badges = header.querySelectorAll('[data-sc-status]');
    for (var i = 0; i < badges.length; i++) {
      var el = badges[i], data, L, s;
      try { L = JSON.parse(el.getAttribute('data-labels')); } catch (e) { L = null; }
      L = L || EN;
      for (var k in EN) if (!L[k]) L[k] = EN[k];
      try { data = JSON.parse(el.getAttribute('data-hours')); s = statusFor(data, L); } catch (e) { s = null; }
      if (!s) continue;
      el.classList.toggle('is-open', s.open);
      el.classList.toggle('is-closed', !s.open);
      el.querySelector('.sc-status__text').textContent = s.text;
    }
  }
  renderStatus();
  setInterval(renderStatus, 60 * 1000);

  /* ---- Announcement bar --------------------------------------------------
     Same cookie the old theme bar used, so an earlier dismissal still holds. */
  var announce = header.querySelector('[data-sc-announce]');
  var section = header.parentElement;

  function syncAnnounceHeight() {    // the bar scrolls away; the nav row stays pinned
    var h = announce && !announce.hidden ? announce.offsetHeight : 0;
    section.style.setProperty('--sc-announce-h', h + 'px');
  }
  if (announce) {
    if (document.cookie.indexOf('alertbtn_cookie=closed') !== -1) announce.hidden = true;
    announce.querySelector('[data-sc-announce-close]').addEventListener('click', function () {
      announce.hidden = true;
      document.cookie = 'alertbtn_cookie=closed; max-age=86400; path=/; SameSite=Lax';
      syncAnnounceHeight();
    });
  }
  syncAnnounceHeight();
  window.addEventListener('resize', syncAnnounceHeight);

  /* ---- Search ------------------------------------------------------------ */
  var searchToggle = header.querySelector('[data-sc-search-toggle]');
  var searchPanel = document.getElementById('sc-search');
  function setSearch(open) {
    if (!searchPanel) return;
    searchPanel.hidden = !open;
    searchToggle.setAttribute('aria-expanded', String(open));
    if (open) searchPanel.querySelector('input[name="q"]').focus();
  }
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () { setSearch(searchPanel.hidden); });
    searchPanel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { setSearch(false); searchToggle.focus(); }
    });
  }

  /* ---- Mobile drawer ----------------------------------------------------- */
  var drawer = header.querySelector('[data-sc-drawer]');
  var openBtn = header.querySelector('[data-sc-drawer-open]');
  var closeBtn = header.querySelector('[data-sc-drawer-close]');
  function setDrawer(open) {
    drawer.hidden = !open;
    openBtn.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('sc-drawer-open', open);
    (open ? closeBtn : openBtn).focus();
  }
  if (drawer && openBtn && closeBtn) {
    openBtn.addEventListener('click', function () { setDrawer(true); });
    closeBtn.addEventListener('click', function () { setDrawer(false); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) setDrawer(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) setDrawer(false);
    });
  }

  /* Drawer accordion: the chevron beside a department opens its links. */
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sc-drawer-toggle]');
      if (!btn) return;
      var sub = document.getElementById(btn.getAttribute('aria-controls'));
      if (!sub) return;
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      sub.hidden = !open;
    });
  }
})();
